namespace TR {
    class HotelReviewsBrowser {

        loadingFirstReviews: boolean;
        selectedHotel: any;
        reviews: any[];
        reviewPaging: any;
        reviewsShowing: any;
        pageReviews: Function;

        constructor(
            private $scope: ng.IScope,
            private broker: any,
            private pagingService: Core.PagingService,
            private reviewService: any
        ) {
            this.broker.subscribe(
                'hotelReviewsBrowser',
                'SHOWREVIEWS',
                this.showReviews.bind(this));

            this.pageReviews = (page) => this.getReviews(this.selectedHotel, page);

            $scope.$on('$destroy', () => {
                broker.unsubscribe('hotelReviewsBrowser');
            });
        }

        private showReviews(e, page = 1) {
            this.selectedHotel = e.data.hotel;
            this.reviewPaging = this.pagingService.data(
                1,
                10,
                this.selectedHotel.CustomerRatingCount
            );
            this.getReviews(e.data.hotel, page);
        }

        private getReviews(hotel, page) {
            if (this.reviewPaging.page === 1) { this.loadingFirstReviews = true; }
            this.reviewsShowing = true;
            return this.reviewService.getReviews(this.selectedHotel, this.reviewPaging.page - 1)
                .then(res => {
                    this.reviews = res.reviews;
                    this.loadingFirstReviews = false;
                    this.reviewPaging = this.pagingService.data(
                        this.reviewPaging.page,
                        10,
                        this.selectedHotel.CustomerRatingCount
                    );
                });
        }
    }

    angular
        .module('TR')
        .directive('hotelReviewsBrowser', (): ng.IDirective => {
            return {
                scope: {},
                templateUrl: 'partials/home/directivetemplate?type=HotelReviewBrowser',
                bindToController: {
                },
                controller: HotelReviewsBrowser,
                controllerAs: 'cm'
            };
        });

}
